import { HomeLine } from '@untitledui/icons';
import {
  Breadcrumbs as AriaBreadcrumbs,
  Breadcrumb as AriaBreadcrumb
} from 'react-aria-components';
import { cx } from '../../../utils/cx';

export type BreadcrumbsProps = {
  className?: string;
  homeUrl?: string;
  link: React.ElementType;
  links: {
    icon?: React.ReactNode;
    href: string;
    label: string;
    hideText?: boolean;
  }[];
  activeUrl?: string;
};

export function Breadcrumbs({
  className,
  homeUrl = '/',
  link: Link = 'a',
  links = [],
  activeUrl
}: BreadcrumbsProps) {
  const linksToRender = [
    {
      icon: <HomeLine size={16} />,
      href: homeUrl,
      label: 'Home',
      hideText: true
    },
    ...links
  ];
  return (
    <AriaBreadcrumbs className={cx('flex items-center', className)}>
      {linksToRender.map((item) => (
        <AriaBreadcrumb
          key={item.href}
          className="flex items-center after:content-['/'] after:px-2 after:flex after:items-center after:font-medium after:text-border-secondary last:after:content-none"
        >
          <Link
            href={item.href}
            aria-label={item.label}
            className={cx(
              'flex items-center justify-center px-(--gn-spacing-md) py-(--gn-spacing-xs) rounded-sm hover:bg-primary_hover hover:text-secondary',
              !item.hideText && 'text-xs font-medium text-quaternary',
              item.href === homeUrl && 'text-fg-quaternary',
              item.href === activeUrl && 'text-secondary'
            )}
          >
            {item.icon}
            {!item.hideText && item.label}
          </Link>
        </AriaBreadcrumb>
      ))}
    </AriaBreadcrumbs>
  );
}
